import { fetchAPI } from './client';

export type FeedbackCategory = 'comment' | 'idea' | 'issue';
export interface FeedbackDraft {
  requestId: string;
  category: FeedbackCategory;
  message: string;
  pageContext: string;
  releaseId: string;
}

export const ProductFeedbackAPI = {
  submit: (draft: FeedbackDraft, signal?: AbortSignal): Promise<{ id: string }> =>
    fetchAPI('/product-feedback', { method: 'POST', body: JSON.stringify(draft), signal }),
  seen: (): Promise<{ releaseIds: string[] }> => fetchAPI('/product-updates/seen'),
  markSeen: (releaseId: string): Promise<void> =>
    fetchAPI('/product-updates/seen', { method: 'POST', body: JSON.stringify({ releaseId }) }),
};
